// 주민등록번호 마스킹 : 뒤 6자
function idNumberMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    const noneMasked = value.slice(0, 6);
    const masked = value.slice(6);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    const result = noneMasked + masking;
    return result;
  }
}

// 전화번호, 사업자등록번호 마스킹 : 뒤 3자부터 4자
function phoneNumberMasking(_value) {
  if (_value) {
    const value = String(_value);
    const forMasked = value.slice(-6);
    const masked = forMasked.slice(0, 4);
    const noneMasked = value.slice(0, value.length - forMasked.length);
    const noneMasked2 = forMasked.slice(4);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    const result = noneMasked + masking + noneMasked2;
    return result;
  } else {
    return "";
  }
}

// 운전면허번호 : 뒤 3자부터 6자
function driversLicenseMasking(_value) {
  if (_value) {
    const value = String(_value);
    const forMasked = value.slice(-8);
    const masked = forMasked.slice(0, 6);
    const noneMasked = value.slice(0, value.length - forMasked.length);
    const noneMasked2 = forMasked.slice(6);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    const result = noneMasked + masking + noneMasked2;
    return result;
  } else {
    return "";
  }
}

// 운전면허증 식별번호 마스킹 : 뒤 2자
function driverUniqueMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    const masked = value.slice(-2);
    const noneMasked = value.slice(0, value.length - masked.length);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    const result = noneMasked + masking;
    return result;
  }
}

// 주소 마스킹 : 'ㅇㅇ로' 다음
function addrMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    if (value.lastIndexOf("로") !== -1) {
      const noneMasked = value.slice(0, value.lastIndexOf("로"));
      const masked = value.slice(noneMasked.length + 1);
      let masking = "";
      for (var i = 0; i < masked.length; i++) {
        masking = masking + "*";
      }
      const addr = noneMasked + "로" + masking;
      return addr;
    } else if (value.lastIndexOf("길") !== -1) {
      const noneMasked = value.slice(0, value.lastIndexOf("길"));
      const masked = value.slice(noneMasked.length + 1);
      let masking = "";
      for (var i = 0; i < masked.length; i++) {
        masking = masking + "*";
      }
      const result = noneMasked + "길" + masking;
      return result;
    } else {
      return value;
    }
  }
}

// 직장명, 부서명, 업체명 마스킹 : 앞 2자
function jobNameMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    const noneMasked = value.slice(2);
    const masked = value.slice(0, 2);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    const result = masking + noneMasked;
    return result;
  }
}

// 계좌번호 마스킹 : 앞 7자부터 끝까지
function accountMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    const noneMasked = value.slice(0, 6);
    const masked = value.slice(6);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    return noneMasked + masking;
  }
}

// 이메일 마스킹 : @앞 3리
function emailMasking(_value) {
  if (_value !== "") {
    const value = String(_value);
    const email = value.split("@")[0];
    const noneMasked = email.slice(0, -3);
    const masked = email.slice(-3);
    let masking = "";
    for (var i = 0; i < masked.length; i++) {
      masking = masking + "*";
    }
    return noneMasked + masking + "@" + value.split("@")[1];
  }
}

export default {
  idNumberMasking,
  phoneNumberMasking,
  driversLicenseMasking,
  addrMasking,
  jobNameMasking,
  accountMasking,
  emailMasking,
  driverUniqueMasking,
};
